export default __webpack_public_path__ + "static/media/eth-collection.6b19d119.jpg";